import React, {useContext}  from 'react';
import { GlobalContext } from '../../../Contexts/GlobalContext';

const Banner = ()=>{

    const {URL} = useContext(GlobalContext);

    const homeBannerImg = URL + "images/home/banner.png";

    return(
    <>
        <div className="homeBanner" style={{ backgroundImage:"url("+ homeBannerImg +")" }}>
            <div className="welcomeAlumni">
                <h2>
                    Welcome Alumni!
                </h2>
                <p>
                    As a LUMS graduate, you are part of a 14,000+ strong network across the globe. This ever-growing community embodies the LUMS spirit and is a lifelong advocate of the LUMS experience.
                </p>
            </div>
            <div className="row readSection">
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 col-wrap">
                    <div className="content">
                        <div className="heading">
                            Read our magazine
                        </div>
                        <div className="text">
                            What’s in it for you? An exciting journey of the LUMS world today!The Alumni Annual explores the stories of alumni doing LUMS proud, and gives you a behind-the-scenes look at all that’s happening at LUMS.
                        </div>
                        <div className="link">
                            <a href="/">
                                More <i className="fa fa-caret-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 col-wrap">
                    <div className="content">
                    <div className="heading">
                            CONNECT WITH CHAPTERS
                        </div>
                        <div className="text">
                        Curious about the global alumni community? New to a city and looking to build connections? Explore our Alumni Chapters and make friends with your local alumni cohort.
                        </div>
                        <div className="link">
                            <a href="/">
                                More <i className="fa fa-caret-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 col-wrap">
                    <div className="content">
                        <div className="heading">
                            ATTEND AN EVENT
                        </div>
                        <div className="text">
                            Curious about the global alumni community? New to a city and looking to build connections? Explore our Alumni Chapters and make friends with your local alumni cohort.
                        </div>
                        <div className="link">
                            <a href="/">
                                More <i className="fa fa-caret-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 col-wrap">
                    <div className="content">
                    <div className="heading">
                            MAKE A DONATION
                        </div>
                        <div className="text">
                        There is nothing quite like the LUMS experience. Help enhance this experience, or help make it possible for another deserving individual. Every gift of support counts.
                        </div>
                        <div className="link">
                            <a href="/">
                                More <i className="fa fa-caret-right"></i>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div className="homeBannerMobile">
        <div className="row readSection ">
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-wrap">
                    <div className="content">
                        <div className="heading">
                            Read our magazine
                        </div>
                        <div className="text">
                            What’s in it for you? An exciting journey of the LUMS world today!The Alumni Annual explores the stories of alumni doing LUMS proud, and gives you a behind-the-scenes look at all that’s happening at LUMS.
                        </div>
                        <div className="link">
                            <a href="/">
                                More <i className="fa fa-caret-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-wrap">
                    <div className="content">
                    <div className="heading">
                            CONNECT WITH CHAPTERS
                        </div>
                        <div className="text">
                        Curious about the global alumni community? New to a city and looking to build connections? Explore our Alumni Chapters and make friends with your local alumni cohort.
                        </div>
                        <div className="link">
                            <a href="/">
                                More <i className="fa fa-caret-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-wrap">
                    <div className="content">
                        <div className="heading">
                            ATTEND AN EVENT
                        </div>
                        <div className="text">
                            Curious about the global alumni community? New to a city and looking to build connections? Explore our Alumni Chapters and make friends with your local alumni cohort.
                        </div>
                        <div className="link">
                            <a href="/">
                                More <i className="fa fa-caret-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-wrap">
                    <div className="content">
                    <div className="heading">
                            MAKE A DONATION
                        </div>
                        <div className="text">
                        There is nothing quite like the LUMS experience. Help enhance this experience, or help make it possible for another deserving individual. Every gift of support counts.
                        </div>
                        <div className="link">
                            <a href="/">
                                More <i className="fa fa-caret-right"></i>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </>
    );

}

export default React.memo(Banner);